import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './apidocument.css';

const ApiDocument = () => {
  const [openFaq, setOpenFaq] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "How to create an API Key?",
      a: "Log in to AGCX, open Profile → API Key Management, and create a new key. Store the secret safely — it is shown only once."
    },
    {
      q: "What are the API rate limits?",
      a: "AGCX API rate limits depend on the endpoint and your account permissions. See the AGCX API documentation for current limits."
    },
    {
      q: "How to start connecting WebSocket?",
      a: "Use the AGCX WebSocket endpoint in the API documentation and subscribe to the market or account channels you need. Authentication is required for private streams."
    },
    {
      q: "Where can I find some API examples?",
      a: "Sample requests and responses are included in the AGCX API documentation. For help implementing a bot or integration, contact support@arabglobal.ae."
    },
    {
      q: "How to get support for API related issues?",
      a: "Open a ticket from your AGCX account or email support@arabglobal.ae. Include your API key name (never the secret) and the endpoint you are calling."
    }
  ];

  return (
    <div className="api-document-wrapper">

      {/* HERO SECTION */}
      <section className="api-hero-section" style={{ backgroundImage: "url('/images/api-document-img/api_documentbg.jpg')" }}>
        <div className="api-hero-container">
          <div className="api-hero-content">
            <span className="api-badge">API Documentation</span>
            <h1>Agcx <span>API</span></h1>
            <p>Experience the fastest, most reliable and scalable data feed for your trading and market strategy.</p>
            <div className="api-btn-group">
              <Link to="/create_api_key" className="btn-black">Create API Key</Link>
              <a href="https://github.com" target="_blank" rel="noreferrer" className="btn-grey">View API Documentation</a>
            </div>
            <div className="api-features-list">
              <span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                High Performance
              </span>
              <span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                Millisecond latency
              </span>
              <span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                24/7 Support
              </span>
            </div>
          </div>
          <div className="api-hero-image">
            <img src="/images/api-document-img/api_document_img.png" alt="API Server Illustration" />
          </div>
        </div>
      </section>

      {/* ALL IN ONE TRADING DATA SECTION */}
      <section className="api-services-section">
        <div className="api-services-container">
          <h2 className="api-section-title">All-in-One Trading Data and Account Services</h2>
          <p className="api-section-subtitle">Access real-time market data, execute trades, and manage your account with Agcx API.</p>

          <div className="api-diagram">
            {/* Top Gray Line */}
            <div className="diagram-top-line">
              <span className="diagram-arrow-left">◀</span>
              <span className="diagram-pill">Apply/Manage API Key</span>
              <span className="diagram-arrow-right">▶</span>
            </div>

            <div className="diagram-main-row">
              <div className="diagram-item">
                <div className="diagram-icon large">
                  <img src="/images/api-document-img/user_api.svg" alt="User" />
                </div>
                <span className="diagram-title">Users</span>
              </div>

              <div className="diagram-line-container">
                <div className="diagram-line-dashed gold">
                  <span className="diagram-arrow-left">◀</span>
                  <span className="diagram-pill">Deploy API</span>
                  <span className="diagram-arrow-right">▶</span>
                </div>
              </div>

              <div className="diagram-item">
                <div className="diagram-icon small">
                  <img src="/images/api-document-img/api_setting.svg" alt="API" />
                </div>
                <span className="diagram-title">API</span>
              </div>

              <div className="diagram-line-container">
                <div className="diagram-line-dashed gold">
                  <span className="diagram-arrow-left">◀</span>
                  <span className="diagram-pill">Transactions and Requests</span>
                  <span className="diagram-arrow-right">▶</span>
                </div>
              </div>

              <div className="diagram-item">
                <div className="diagram-icon large">
                  <img src="/images/api-document-img/agcx_api_logo.svg" alt="AGCX" />
                </div>
                <span className="diagram-title">AGCX</span>
              </div>
            </div>
          </div>

          <div className="api-cards-grid">
            {/* Spot Trading Card */}
            <div className="api-card">
              <h3>Spot Trading</h3>
              <div className="api-tags">
                <span className="api-tag">Spot Trading</span>
                <span className="api-tag">Margin Trading</span>
                <span className="api-tag">Sub-Account</span>
                <span className="api-tag">Wallet</span>
              </div>
              <div className="api-card-bottom">
                <div className="api-hot-module">Websocket</div>
                <Link to="/trade/BTC_USDT" className="api-card-action">
                  Spot Account Trading
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </Link>
              </div>
            </div>
            {/* Derivatives Trading Card */}
            <div className="api-card">
              <h3>Derivatives Trading</h3>
              <div className="api-tags">
                <span className="api-tag">USDT-M</span>
                <span className="api-tag">Vanilla Options</span>
              </div>
              <div className="api-card-bottom">
                <div className="api-hot-module">Websocket</div>
                <Link to="/futures_trade/BTC_USDT" className="api-card-action">
                  Account Trading API
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </Link>
              </div>
            </div>
          </div>

          <div className='market_data_section'>

            <div className="api-divider">
              <span>Market & Quotation Data</span>
            </div>
            <p>
              Get real-time market data to make trade decisions and monitor your trading strategy.
            </p>

            <div className="api-cards-grid">
              <div className="api-card">
                <h3>WebSocket</h3>
                <p>Get real-time updates with WebSocket connection for market quotes and private corporate future transactions.</p>
                <div className="api-tags" style={{ paddingBottom: 0, marginTop: 'auto' }}>
                  <span className="api-tag">Spot & Margin</span>
                  <span className="api-tag">Perpetual Futures</span>
                  <span className="api-tag">Options</span>
                </div>
              </div>
              <div className="api-card">
                <h3>Historical Quotation Data</h3>
                <p>Download public market data including candlestick data, tick-level trade data, order book depth, and funding rate operations.</p>
                <div className="api-tags" style={{ paddingBottom: 0, marginTop: 'auto' }}>
                  <span className="api-tag">Copy Trading V1</span>
                  <span className="api-tag">Perpetual Futures</span>
                </div>
              </div>
            </div>

          </div>

          <div className='market_data_section'>

            <div className="api-divider">
              <span>SDK & Developer Tools</span>
            </div>
            <p>
              Simplify integration and speed up your development with ready-made SDK packages.
            </p>

            <div className="api-cards-grid">
              <div className="api-card">
                <h3>SDK-API</h3>
                <p>Execute API commands smoothly using pre-configured packages.</p>
                <div className="api-tags" style={{ paddingBottom: 0, marginTop: 'auto' }}>
                  <span className="api-tag">Node.js</span>
                </div>
              </div>
              <div className="api-card">
                <h3>SDK-WebSocket</h3>
                <p>Provide efficient tools enabling faster connection establishment for market quotes and account trading updates.</p>
                <div style={{ marginTop: 'auto' }}>
                  <a href="https://github.com" target="_blank" rel="noreferrer" className="api-github-btn">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>
                    View on GitHub
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="api-benefits-section" style={{ backgroundImage: "url('/images/api-document-img/benifits_api_bg.jpg')" }}>
        <div className="api-benefits-container">
          <div className="api-divider" style={{ margin: '0 0 10px 0' }}>
            <span>Benefits for AGCX Members</span>
          </div>
          <div className="api-benefits-grid">
            <div className="api-benefit-card">
              <h4>Welcome Rewards</h4>
              <p>Up to 5,000 bonus to trade in futures trading account, holding periods, and other terms based upon rules and conditions.</p>
            </div>
            <div className="api-benefit-card">
              <h4>Referral Program</h4>
              <p>Invite friends and up to 40% commission rebates on their trading fees. Earn passive income from your network effortlessly.</p>
            </div>
            <div className="api-benefit-card">
              <h4>VIP Trading Benefits</h4>
              <p>Enjoy lower trading fees, higher withdrawal limits, priority customer support, and exclusive VIP privileges as your trading volume grows.</p>
            </div>
            <div className="api-benefit-card">
              <h4>Earn & Staking Rewards</h4>
              <p>Put your crypto to work with flexible earning options, staking rewards, and yield generation opportunities available on the platform.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="api-faq-section">
        <div className="api-faq-container">
          <h2>Frequently Asked Questions</h2>

          {faqs.map((faq, index) => (
            <div key={index}>
              <div
                className="api-faq-item"
                onClick={() => toggleFaq(index)}
                style={{ borderRadius: openFaq === index ? '8px 8px 0 0' : '8px' }}
              >
                <span>{faq.q}</span>
                <span className={`api-faq-icon ${openFaq === index ? 'open' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </span>
              </div>
              {openFaq === index && (
                <div className="api-faq-answer">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ApiDocument;
